<template>
    <FontAwesomeIcon :icon="iconClass" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
    components: { FontAwesomeIcon },
    props: {
        icon: {
            type: [String, Array],
            required: true,
        },
    },
    data() {
        return {
            defaultIconFamily: 'fas',
            definedIcons: new Map([
                ['change', ['fas', 'arrow-turn-left']],
                ['store', ['fas', 'clock']],
                ['next', ['fas', 'angle-right']],
                ['previous', ['fas', 'angle-left']],
                ['maintenance', ['fas', 'person-digging']],
                ['schedule', ['fas', 'circle-plus']],
                ['warning', ['fas', 'triangle-exclamation']],
                ['serviceAppointment', ['fas', 'wrench']],
                ['roadsideAssistance', ['fas', 'face-frown']],
                ['adviserSelectionAppointment', ['fas', 'users']],
                ['freeAppointment', ['fas', 'calendar-days']],
                ["check", ["fas", "check-circle"]],
                ["close", ["fas", "times-circle"]],
                ["biography", ["fas", "file-user"]],

            ]),
        }
    },

    computed: {
        iconClass() {
            if (Array.isArray(this.icon)) {
                return this.icon
            } else if (this.definedIcons.has(this.icon)) {
                return this.definedIcons.get(this.icon)
            }
            return [this.defaultIconFamily, this.icon]
        },
    },
});
</script>
